import type { SlideWithLinkProps } from '@velasca/types'
import { buildIntrinsicWidthSources } from '@velasca/utils/build-intrinsic-width-sources'
import { setQueryParams } from '@velasca/utils/set-query-params'
import { SansTitle } from '../SansTitle/SansTitle'
import { Image, ImageContainer, LinkContainer } from './SlideWithLink.styles'

export const SlideWithLink = ({
  image,
  title,
  url,
}: SlideWithLinkProps): JSX.Element => {
  return (
    <LinkContainer href={url}>
      {image && (
        <ImageContainer>
          <Image
            lqip
            lazyload
            alt={image.alt}
            sources={buildIntrinsicWidthSources({ src: image.src })}
            imgSrc={setQueryParams(image.src, [{ name: 'width', value: '30' }])}
          />
        </ImageContainer>
      )}

      {title && (
        <SansTitle tracking="wide" as="h3">
          {title}
        </SansTitle>
      )}
    </LinkContainer>
  )
}
